export interface IsModalOpenProps {
  open: 'DimensionsModal' | 'ParametersModal' | 'GeneralInfo' | null;
  addNewQuantitativo?: boolean;
  isExported?: boolean;
}

export interface MeasuresProps {
  largura: number | undefined;
  comprimento: number | undefined;
  distanciaPort: number;
  altura: number;
}

export interface UserDataProps {
  nome: string;
  email: string;
  profissao: string;
}

export interface AlertModalInterface {
  open: boolean;
  submitDangerous: boolean;
  title: string;
  description?: string;
  icon: React.JSX.Element | null;
  textSubmit?: string;
  textCancel?: string;
  loader?: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
}

export const defaultStateAlertModal: AlertModalInterface = {
  open: false,
  icon: null,
  title: '',
  description: '',
  textSubmit: '',
  textCancel: '',
  submitDangerous: false,
  loader: false,
  onSubmit: () => {},
};
